export const RECORD_VERSION = 1;
export const RECORD_EXTENSION = '.jsontool.json';

export function createRecord({ title, note = '', data, now = new Date(), id = crypto.randomUUID() }) {
  const normalizedTitle = title.trim();
  if (!normalizedTitle) throw new Error('标题不能为空。');
  const timestamp = now.toISOString();
  return {
    schemaVersion: RECORD_VERSION,
    id,
    title: normalizedTitle,
    note: note.trim(),
    createdAt: timestamp,
    updatedAt: timestamp,
    data,
  };
}

export function updateRecord(record, { title, note = '', data, now = new Date() }) {
  const normalizedTitle = title.trim();
  if (!normalizedTitle) throw new Error('标题不能为空。');
  return {
    ...record,
    title: normalizedTitle,
    note: note.trim(),
    updatedAt: now.toISOString(),
    data,
  };
}

export function validateRecord(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { ok: false, error: '文件内容不是记录对象。' };
  }
  if (value.schemaVersion !== RECORD_VERSION) {
    return { ok: false, error: `不支持的记录版本：${String(value.schemaVersion)}` };
  }
  const requiredStrings = ['id', 'title', 'createdAt', 'updatedAt'];
  if (requiredStrings.some((key) => typeof value[key] !== 'string' || !value[key].trim())) {
    return { ok: false, error: '记录缺少必要的元信息。' };
  }
  if (!Object.prototype.hasOwnProperty.call(value, 'data')) {
    return { ok: false, error: '记录缺少 data 字段。' };
  }
  return { ok: true, value: { ...value, note: typeof value.note === 'string' ? value.note : '' } };
}

export function makeRecordFilename(title, id) {
  const safeTitle = title
    .normalize('NFKC')
    .replace(/[\\/:*?"<>|\u0000-\u001f]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '')
    .slice(0, 60) || 'json-record';
  return `${safeTitle}--${id}${RECORD_EXTENSION}`;
}
